const ConfirmDeleteModal = () => (
  <svg
    width="40"
    height="40"
    viewBox="13.3333 6.6666 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 14.6666C13.3333 10.2483 16.915 6.66663 21.3333 6.66663H45.3333C49.7515 6.66663 53.3333 10.2483 53.3333 14.6666V38.6666C53.3333 43.0849 49.7515 46.6666 45.3333 46.6666H21.3333C16.915 46.6666 13.3333 43.0849 13.3333 38.6666V14.6666Z"
      fill="#D71313"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.3333 18.3333C28.731 18.3333 25 22.0642 25 26.6666C25 31.269 28.731 34.9999 33.3333 34.9999C37.9357 34.9999 41.6667 31.269 41.6667 26.6666C41.6667 22.0642 37.9357 18.3333 33.3333 18.3333ZM33.3333 24.1666C33.0189 24.1666 32.7439 24.3404 32.6012 24.6012C32.3804 25.005 31.874 25.1533 31.4702 24.9324C31.0664 24.7116 30.9181 24.2052 31.139 23.8014C31.5622 23.0277 32.3855 22.4999 33.3333 22.4999C34.5956 22.4999 35.4724 23.3386 35.722 24.3241C35.973 25.3148 35.5917 26.4691 34.4514 27.0393C34.2769 27.1265 34.1667 27.3048 34.1667 27.4999C34.1667 27.9602 33.7936 28.3333 33.3333 28.3333C32.8731 28.3333 32.5 27.9602 32.5 27.4999C32.5 26.6736 32.9669 25.9181 33.706 25.5486C34.085 25.3591 34.1823 25.033 34.1064 24.7333C34.0292 24.4284 33.7736 24.1666 33.3333 24.1666ZM33.3333 30.8333C33.7936 30.8333 34.1667 30.4602 34.1667 29.9999C34.1667 29.5397 33.7936 29.1666 33.3333 29.1666C32.8731 29.1666 32.5 29.5397 32.5 29.9999C32.5 30.4602 32.8731 30.8333 33.3333 30.8333Z"
      fill="white"
    />
  </svg>
)

export default ConfirmDeleteModal
